var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyDocsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9171 11C15.3253 11 15.6562 10.7202 15.6562 10.375V2.5C15.6562 1.1215 14.3299 0 12.6997 0H3.61272C1.98252 0 0.65625 1.1215 0.65625 2.5V13.5C0.65625 14.8785 1.98252 16 3.61272 16H12.6997C14.33 16 15.6562 14.8785 15.6562 13.5C15.6562 13.1548 15.3253 12.875 14.9171 12.875C14.5089 12.875 14.178 13.1548 14.178 13.5C14.178 14.1892 13.5149 14.75 12.6998 14.75H3.61272C2.79762 14.75 2.13449 14.1892 2.13449 13.5V2.5C2.13449 1.81075 2.79762 1.25 3.61272 1.25H12.6998C13.5149 1.25 14.178 1.81075 14.178 2.5V10.375C14.178 10.7202 14.5089 11 14.9171 11Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2188 3.75H4.78125C4.43606 3.75 4.15625 4.02981 4.15625 4.375C4.15625 4.72019 4.43606 5 4.78125 5H11.2188C11.5639 5 11.8438 4.72019 11.8438 4.375C11.8438 4.02981 11.5639 3.75 11.2188 3.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2188 6.25H4.78125C4.43606 6.25 4.15625 6.52981 4.15625 6.875C4.15625 7.22019 4.43606 7.5 4.78125 7.5H11.2188C11.5639 7.5 11.8438 7.22019 11.8438 6.875C11.8438 6.52981 11.5639 6.25 11.2188 6.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69094 8.75H4.78125C4.43606 8.75 4.15625 9.02981 4.15625 9.375C4.15625 9.72019 4.43606 10 4.78125 10H8.691C9.03619 10 9.31597 9.72019 9.31597 9.375C9.31594 9.02981 9.03613 8.75 8.69094 8.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDocsIcon);
export default __webpack_public_path__ + "static/media/myDocsIcon.4b5b4562f85658dbf59d4d4505070d14.svg";
export { ForwardRef as ReactComponent };